module.exports = __webpack_public_path__ + "static/arif-riyanto-G1N9kDHqBrQ-unsplash@2x-127bf3f953b43a720a2b712963726300.png";